import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppShell } from "@/components/app-shell";

/**
 * Oturum koruması.
 *
 * `beforeLoad` yalnızca `signedOut` ve `inactive` durumlarında yönlendiriyor;
 * `loading` durumu buraya hiç ulaşmıyor çünkü uygulama, oturum çözülene kadar
 * yönlendiriciyi (router) hiç kurmuyor (bkz. src/app.tsx). Aksi hâlde sayfa
 * her yenilendiğinde bir an giriş ekranı görünürdü.
 */
export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context, location }) => {
    if (context.auth.status !== "signedIn") {
      throw redirect({
        to: "/giris",
        search: { redirect: location.href },
      });
    }
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
